import { Box, styled } from "@mui/material";

export const MainContainer = styled(Box)({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "14px 20px",
  position: "relative",
  overflow: "hidden",
  "& .typography1": {
    color: "#5888C4",
    fontWeight: 900,
    fontSize: 22,
    fontFamily: "sans-serif",
    letterSpacing: "-0.01em",
    marginTop: "0",
    textAlign: "center"
  },
  "& .typography2": {
    marginTop: "1rem",
    justifyContent: "center",
    color: "#bababa",
    fontSize: 22,
    fontWeight: 500,
    fontFamily: "sans-serif",
    textAlign: "center",
    pointerEvents: "none",
  },
});

export const FooterWrapper = styled(Box)({
  textAlign: "center",
  padding: "1em 0",
  position: "relative",
  bottom: 10,
  left: 0,
  right: 0,
  paddingBottom: 70
});

export const StatusIcon = styled(Box)({
  display: "flex",
  justifyContent: "center",
  marginTop: "9rem",
});

export const StatusMessageContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  marginTop: "1rem",
  width: "100%",
  whiteSpace: "pre-line",
});
